import React, { Component } from 'react';
import { Form, Radios, Button } from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class Decision extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="Decision">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="Decision__Form"
        >
          <h1>{translate('fiche.decision.title')}</h1>
          <p>{translate('fiche.decision.subtitle')}</p>
          <Radios
            vertical
            name="decision"
            rules={['required']}
            data={[
              {
                value: "1",
                label: translate('fiche.decision.suitable'),
                checked: data.decision == "1"
              },
              {
                value: "0",
                label: translate('fiche.decision.unsuitable'),
                checked: data.decision == "0"
              }
            ]}
          />

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(Decision);
